/* Sleepless Studio: Custom Studio quote builder.
   Products, prices and text come from the theme editor (section "Custom Studio: quote builder").
   Price tiers format: "min qty:price" separated by commas, e.g. "1:18, 10:15, 25:13, 50:11.50, 100:quote". */
(function () {
  'use strict';

  var ICON = {
    check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    check16: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    minus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    x: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    trend: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7l6 6 4-4 8 8"/><path d="M21 11v6h-6"/></svg>',
    info: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7E8A97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>',
    clock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    file: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H6v18h12V7z"/><path d="M14 3v4h4"/></svg>',
    image: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 16-5-5-9 9"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) { return '£' + n.toFixed(2); }
  function parseTiers(str) {
    if (!str) return [];
    return String(str).split(',').map(function (s) { return s.trim(); }).filter(Boolean).map(function (part) {
      var bits = part.split(':');
      var min = parseInt(bits[0], 10);
      var raw = (bits[1] || '').trim();
      var price = /quote/i.test(raw) ? null : parseFloat(raw);
      return { min: min, price: (price === null || isNaN(price)) ? null : price };
    }).filter(function (t) { return !isNaN(t.min); }).sort(function (a, b) { return a.min - b.min; });
  }
  function rangeLabel(tiers, i) {
    var t = tiers[i], nx = tiers[i + 1];
    if (!nx) return t.min + '+';
    return nx.min - 1 > t.min ? t.min + '–' + (nx.min - 1) : String(t.min);
  }
  function tierIdx(tiers, q) {
    var i = 0;
    tiers.forEach(function (t, k) { if (q >= t.min) i = k; });
    return i;
  }
  var SWATCH = { black: '#1A1A1A', white: '#FFFFFF', cream: '#F1E8D3', navy: '#1F2A44', grey: '#9A9EA3', gray: '#9A9EA3' };
  function swatch(name) {
    var hex = SWATCH[String(name).trim().toLowerCase()];
    return hex ? '<span class="cs-swatch" style="background:' + hex + '" aria-hidden="true"></span>' : '';
  }
  function list(str) { return String(str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }

  function Builder(root) {
    this.root = root;
    this.c = JSON.parse(root.querySelector('[data-cs-config]').textContent);
    var self = this;
    this.products = this.c.products.map(function (p) {
      var opts = (p.opts || []).filter(function (o) { return o.label; }).map(function (o) { return { label: o.label, tiers: parseTiers(o.tiers) }; });
      var q = {
        id: p.id, name: p.name || 'Product', spec: p.spec || '', desc: p.desc || '', category: p.category || 'Other',
        img: p.img, alt: p.alt || p.name, unit: p.unit || 'units', note: p.note || '',
        min: Math.max(1, parseInt(p.min, 10) || 1),
        def: parseInt(p.def, 10) || 0,
        defOpt: Math.max(0, (parseInt(p.defOpt, 10) || 1) - 1),
        picks: list(p.picks).map(function (n) { return parseInt(n, 10); }).filter(function (n) { return n > 0; }),
        tiers: parseTiers(p.tiers), planned: parseTiers(p.planned), opts: opts, optLabel: p.optLabel || 'Option',
        colours: list(p.colours), colourLabel: p.colourLabel || 'Colour',
        addonLabel: p.addonLabel || '', addon: parseFloat(p.addonPrice) || 0, addonHelp: p.addonHelp || '',
        setup: parseFloat(p.setup) || 0, minOrder: parseFloat(p.minOrder) || 0, fromText: p.fromText || ''
      };
      if (!q.fromText) {
        var all = q.tiers.concat(q.planned);
        q.opts.forEach(function (o) { all = all.concat(o.tiers); });
        var prices = all.map(function (t) { return t.price; }).filter(function (v) { return v !== null; });
        q.fromText = prices.length ? 'from ' + money(Math.min.apply(null, prices)) + ' each' : 'Priced by quote';
      }
      if (q.defOpt >= q.opts.length) q.defOpt = 0;
      return q;
    });
    this.s = { step: 1, cat: 'all', q: '', sel: {}, cfg: {}, lead: 'standard' };
    this.files = [];
    this.$ = function (sel) { return root.querySelector(sel); };
    this.form = this.$('[data-cs-form]');
    this.bind();
    this.renderAll();
  }

  Builder.prototype.byId = function (id) { return this.products.filter(function (p) { return p.id === id; })[0]; };
  Builder.prototype.selected = function () { var s = this.s; return this.products.filter(function (p) { return s.sel[p.id]; }); };
  Builder.prototype.defCfg = function (p) { return { qty: Math.max(p.min, p.def || p.min), opt: p.defOpt, colour: 0, addon: false }; };
  Builder.prototype.hasPlanned = function () { return this.selected().some(function (p) { return p.planned.length && !p.opts.length; }); };

  Builder.prototype.tiersFor = function (p, c) {
    if (p.opts.length) return p.opts[c.opt] ? p.opts[c.opt].tiers : [];
    if (this.s.lead === 'planned' && p.planned.length) return p.planned;
    return p.tiers;
  };

  Builder.prototype.price = function (p, c) {
    var tiers = this.tiersFor(p, c);
    if (!tiers.length) return { quote: true, hint: p.fromText };
    var i = tierIdx(tiers, c.qty), t = tiers[i];
    if (t.price === null) return { quote: true, hint: 'Large order: we’ll price this with your proof.' };
    var add = c.addon ? p.addon : 0;
    var unit = t.price + add, raw = unit * c.qty;
    var total = Math.max(raw, p.minOrder);
    var setup = (p.setup > 0 && c.qty < this.c.setupBelow) ? p.setup : 0;
    var hint = '';
    if (raw < p.minOrder) hint = money(p.minOrder) + ' minimum order applied';
    else if (!p.opts.length && this.s.lead === 'standard' && p.planned.length) {
      var pt = p.planned[tierIdx(p.planned, c.qty)];
      if (pt && pt.price !== null && pt.price < t.price) hint = 'Choose “Planned ahead” below to drop to ' + money(pt.price + add) + ' each';
    }
    if (!hint) {
      var nx = tiers[i + 1];
      hint = nx ? (nx.price === null ? nx.min + '+ is priced by quote' : 'Order ' + nx.min + '+ to drop to ' + money(nx.price + add) + ' each') : 'Best price tier reached';
    }
    return { quote: false, unit: unit, total: total, setup: setup, hint: hint };
  };

  Builder.prototype.totals = function () {
    var self = this, items = 0, setup = 0, anyQuote = false, anyLarge = false;
    this.selected().forEach(function (p) {
      var c = self.s.cfg[p.id], pr = self.price(p, c);
      if (c.qty >= self.c.largeQty) anyLarge = true;
      if (pr.quote) anyQuote = true; else { items += pr.total; setup += pr.setup; }
    });
    var tidyOn = this.artValue() === 'tidy';
    var tidy = tidyOn ? this.c.tidyFee : 0;
    return { items: items, setup: setup, tidy: tidy, total: items + setup + tidy, anyQuote: anyQuote, anyLarge: anyLarge };
  };

  Builder.prototype.artValue = function () {
    var r = this.form.querySelector('input[data-cs-art]:checked');
    return r ? r.getAttribute('data-cs-art') : '';
  };

  /* ---------- Rendering ---------- */
  Builder.prototype.renderAll = function () {
    this.renderStepper();
    this.renderStep1();
    this.renderLines();
    this.renderSummary();
    var s = this.s.step;
    this.$('[data-cs-step1]').hidden = s !== 1;
    this.$('[data-cs-layout]').hidden = s === 1;
    [2, 3, 4].forEach(function (n) { this.$('[data-cs-stepblock="' + n + '"]').hidden = s !== n; }, this);
  };

  Builder.prototype.renderStepper = function () {
    var names = this.c.stepNames, cur = this.s.step;
    this.$('[data-cs-stepper]').innerHTML = names.map(function (label, i) {
      var n = i + 1, cls = n < cur ? 'is-done' : n === cur ? 'is-current' : '';
      return '<li class="' + cls + '"' + (n === cur ? ' aria-current="step"' : '') + '><div class="cs-stepper__node"><span class="cs-stepper__dot">' + (n < cur ? ICON.check16 : n) + '</span><span class="cs-stepper__label">' + esc(label) + '</span></div>' + (n < names.length ? '<span class="cs-stepper__bar" aria-hidden="true"></span>' : '') + '</li>';
    }).join('');
  };

  Builder.prototype.renderStep1 = function () {
    var self = this, s = this.s;
    var cats = ['all'];
    this.products.forEach(function (p) { if (cats.indexOf(p.category) < 0) cats.push(p.category); });
    this.$('[data-cs-cats]').innerHTML = cats.map(function (c) {
      var on = s.cat === c;
      return '<button type="button" class="cs-pill' + (on ? ' is-on' : '') + '" data-action="cat" data-value="' + esc(c) + '" aria-pressed="' + on + '">' + esc(c === 'all' ? self.c.allLabel : c) + '</button>';
    }).join('');
    var q = s.q.trim().toLowerCase();
    var shown = this.products.filter(function (p) {
      return (s.cat === 'all' || p.category === s.cat) && (!q || (p.name + ' ' + p.spec + ' ' + p.desc + ' ' + p.category).toLowerCase().indexOf(q) >= 0);
    });
    this.$('[data-cs-grid]').innerHTML = shown.map(function (p) {
      var on = !!s.sel[p.id];
      var media = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.alt) + '" loading="lazy" width="600" height="600">' : ICON.image;
      return '<button type="button" class="cs-pcard' + (on ? ' is-on' : '') + '" data-action="toggle" data-id="' + esc(p.id) + '" aria-pressed="' + on + '">' +
        '<span class="cs-pcard__media">' + media + '<span class="cs-pcard__check">' + (on ? ICON.check : '') + '</span></span>' +
        '<span class="cs-pcard__body">' + (p.spec ? '<span class="cs-pcard__spec">' + esc(p.spec) + '</span>' : '') +
        '<span class="cs-pcard__name">' + esc(p.name) + '</span>' + (p.desc ? '<span class="cs-pcard__desc">' + esc(p.desc) + '</span>' : '') +
        '<span class="cs-chips"><span class="cs-chip cs-chip--from">' + esc(p.fromText) + '</span><span class="cs-chip">' + (p.min > 1 ? 'Min ' + p.min : 'From 1 unit') + '</span></span></span></button>';
    }).join('');
    this.$('[data-cs-noresults]').hidden = shown.length > 0;
    var n = this.selected().length;
    var count = this.$('[data-cs-count]');
    count.textContent = n;
    count.classList.toggle('is-on', n > 0);
    this.$('[data-cs-selhead]').textContent = n === 0 ? this.c.selectNone : n === 1 ? '1 product selected' : n + ' products selected';
    this.$('[data-cs-next1]').disabled = n === 0;
  };

  Builder.prototype.pills = function (p, items, action, current) {
    return items.map(function (it, i) {
      var on = i === current;
      return '<button type="button" class="cs-pill' + (on ? ' is-on' : '') + '" data-action="' + action + '" data-id="' + esc(p.id) + '" data-value="' + i + '" aria-pressed="' + on + '">' + it + '</button>';
    }).join('');
  };

  Builder.prototype.renderLines = function () {
    var self = this, s = this.s, sel = this.selected();
    this.$('[data-cs-lines]').innerHTML = sel.map(function (p) {
      var c = s.cfg[p.id], pr = self.price(p, c), tiers = self.tiersFor(p, c);
      var add = c.addon ? p.addon : 0;
      var thumb = p.img ? '<img src="' + esc(p.img) + '" alt="" width="64" height="64">' : '';
      var html = '<div class="cs-line">' +
        '<div class="cs-line__head"><span class="cs-line__thumb">' + thumb + '</span><div class="cs-line__title"><div class="cs-line__name">' + esc(p.name) + '</div><div class="cs-line__spec">' + esc(p.spec) + '</div></div>' +
        '<button type="button" class="cs-iconbtn" data-action="remove" data-id="' + esc(p.id) + '" aria-label="Remove ' + esc(p.name) + '">' + ICON.x + '</button></div>' +
        '<div class="cs-line__body"><div class="cs-col"><div class="cs-field"><span class="cs-label" id="q-' + esc(p.id) + '">Quantity <small>(' + esc(p.unit) + ')</small></span>' +
        '<div class="cs-qty"><button type="button" data-action="dec" data-id="' + esc(p.id) + '" aria-label="Decrease quantity">' + ICON.minus + '</button>' +
        '<input type="number" inputmode="numeric" min="' + p.min + '" value="' + c.qty + '" data-action="qty" data-id="' + esc(p.id) + '" aria-labelledby="q-' + esc(p.id) + '">' +
        '<button type="button" data-action="inc" data-id="' + esc(p.id) + '" aria-label="Increase quantity">' + ICON.plus + '</button></div>' +
        (p.picks.length ? '<div class="cs-chiprow">' + p.picks.map(function (n) {
          var on = c.qty === n;
          return '<button type="button" class="cs-pill' + (on ? ' is-on' : '') + '" data-action="pick" data-id="' + esc(p.id) + '" data-value="' + n + '" aria-pressed="' + on + '">' + n + '</button>';
        }).join('') + '</div>' : '') + '</div></div><div class="cs-col">';
      if (p.opts.length) html += '<div class="cs-field"><span class="cs-label">' + esc(p.optLabel) + '</span><div class="cs-chiprow">' + self.pills(p, p.opts.map(function (o) { return esc(o.label); }), 'opt', c.opt) + '</div></div>';
      if (p.colours.length) html += '<div class="cs-field"><span class="cs-label">' + esc(p.colourLabel) + '</span><div class="cs-chiprow">' + self.pills(p, p.colours.map(function (n) { return swatch(n) + esc(n); }), 'colour', c.colour) + '</div></div>';
      if (p.addonLabel) html += '<button type="button" class="cs-check' + (c.addon ? ' is-on' : '') + '" data-action="addon" data-id="' + esc(p.id) + '" aria-pressed="' + c.addon + '"><span class="cs-check__box">' + ICON.check + '</span><span class="cs-check__text"><span class="cs-check__title">' + esc(p.addonLabel) + ' +' + money(p.addon) + ' each</span>' + (p.addonHelp ? '<span class="cs-check__sub">' + esc(p.addonHelp) + '</span>' : '') + '</span></button>';
      if (p.note) html += '<div class="cs-note">' + ICON.info + '<span>' + esc(p.note) + '</span></div>';
      html += '</div></div>';
      if (tiers.length) {
        var idx = tierIdx(tiers, c.qty);
        html += '<div class="cs-tiers"><div class="cs-tiers__head"><span class="cs-label">' + esc(self.c.priceListLabel) + '</span><span class="cs-tiers__cap">Price each' + (p.opts.length ? ', ' + esc(p.opts[c.opt].label) : '') + (c.addon ? ', ' + esc(p.addonLabel.toLowerCase()) : '') + (p.setup ? '. ' + money(p.setup) + ' setup on 1–' + (self.c.setupBelow - 1) : '') + (p.minOrder ? '. ' + money(p.minOrder) + ' minimum' : '') + '.</span></div>' +
          '<ul aria-label="Price list for ' + esc(p.name) + '">' + tiers.map(function (t, k) {
            var on = k === idx;
            return '<li class="cs-tier' + (on ? ' is-on' : '') + '"' + (on ? ' aria-current="true"' : '') + '><span class="cs-tier__range">' + rangeLabel(tiers, k) + '</span><span class="cs-tier__price">' + (t.price === null ? 'Quote' : money(t.price + add)) + '</span>' + (on ? '<span class="cs-tier__you">Your price</span>' : '') + '</li>';
          }).join('') + '</ul></div>';
      }
      if (c.qty >= self.c.largeQty) html += '<div class="cs-note cs-note--warn">' + ICON.clock + '<span>' + esc(self.c.largeNote) + '</span></div>';
      html += '<div class="cs-line__foot"><div class="cs-line__nudge">' + ICON.trend + '<span>' + esc(pr.hint) + '</span></div><div class="cs-line__price"><span class="cs-line__unit">' +
        (pr.quote ? 'Priced in your quote' : money(pr.unit) + ' each' + (pr.setup ? ' + ' + money(pr.setup) + ' setup' : '')) + '</span><span class="cs-line__total">' + (pr.quote ? 'Quote' : money(pr.total + pr.setup)) + '</span></div></div></div>';
      return html;
    }).join('');
    this.$('[data-cs-nolines]').hidden = sel.length > 0;
    this.$('[data-cs-next2]').disabled = sel.length === 0;
    var lead = this.$('[data-cs-lead]');
    lead.hidden = !this.hasPlanned();
    lead.querySelectorAll('[data-action="lead"]').forEach(function (b) {
      var on = b.getAttribute('data-value') === s.lead;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
  };

  Builder.prototype.meta = function (p, c) {
    var m = c.qty + ' ' + p.unit;
    if (p.opts.length) m += ', ' + p.opts[c.opt].label;
    if (p.colours.length) m += ', ' + p.colours[c.colour];
    if (c.addon) m += ', ' + p.addonLabel.toLowerCase();
    return m;
  };

  Builder.prototype.renderSummary = function () {
    var self = this, t = this.totals();
    this.$('[data-cs-sum-items]').innerHTML = this.selected().map(function (p) {
      var c = self.s.cfg[p.id], pr = self.price(p, c);
      return '<li><span class="cs-summary__thumb">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="40" height="40">' : '') + '</span><span class="cs-summary__name">' + esc(p.name) + '<small>' + esc(self.meta(p, c)) + (pr.setup ? ', incl. setup' : '') + '</small></span><span class="cs-summary__amt">' + (pr.quote ? 'Quote' : money(pr.total + pr.setup)) + '</span></li>';
    }).join('');
    this.root.querySelectorAll('[data-cs-total]').forEach(function (el) { el.textContent = money(t.total); });
    this.$('[data-cs-sum-products]').textContent = money(t.items);
    this.$('[data-cs-sum-setup]').textContent = money(t.setup);
    this.$('[data-cs-sum-tidyrow]').hidden = !t.tidy;
    this.$('[data-cs-sum-tidy]').textContent = money(t.tidy);
    this.$('[data-cs-sum-large]').hidden = !t.anyLarge;
    this.$('[data-cs-sum-quote]').hidden = !t.anyQuote;
  };

  /* ---------- Upload (based on Jack's product-page upload code) ---------- */
  Builder.prototype.allowed = function () { return list(this.c.allowed.toLowerCase()); };
  Builder.prototype.addFiles = function (fileList) {
    var allowed = this.allowed(), maxB = this.c.maxMb * 1024 * 1024, self = this, bad = [];
    Array.prototype.forEach.call(fileList, function (f) {
      var ext = '.' + f.name.split('.').pop().toLowerCase();
      if (allowed.indexOf(ext) < 0) bad.push(f.name + ' is not an accepted file type');
      else if (f.size > maxB) bad.push(f.name + ' is over ' + self.c.maxMb + ' MB');
      else if (!self.files.some(function (x) { return x.name === f.name && x.size === f.size; })) self.files.push(f);
    });
    this.syncFiles();
    var err = this.$('[data-cs-file-error]');
    err.textContent = bad.length ? bad.join('. ') + '. Accepted: ' + this.c.allowedLabel + '.' : '';
    err.hidden = !bad.length;
  };
  Builder.prototype.syncFiles = function () {
    var holder = this.$('[data-cs-file-inputs]');
    holder.innerHTML = '';
    this.files.forEach(function (f, i) {
      var input = document.createElement('input');
      input.type = 'file';
      input.name = 'properties[Artwork ' + (i + 1) + ']';
      input.hidden = true;
      var dt = new DataTransfer();
      dt.items.add(f);
      input.files = dt.files;
      holder.appendChild(input);
    });
    this.$('[data-cs-files]').innerHTML = this.files.map(function (f, i) {
      return '<li>' + ICON.file + '<span>' + esc(f.name) + '</span><button type="button" class="cs-iconbtn" data-action="unfile" data-value="' + i + '" aria-label="Remove ' + esc(f.name) + '">' + ICON.x + '</button></li>';
    }).join('');
    this.$('[data-cs-filecount]').textContent = this.files.length ? (this.files.length === 1 ? '1 file added' : this.files.length + ' files added') : 'No file chosen';
  };

  /* ---------- Events ---------- */
  Builder.prototype.go = function (step) {
    this.s.step = step;
    this.renderAll();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.$('[data-cs-stepper]').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  };

  Builder.prototype.setQty = function (id, q) {
    var p = this.byId(id);
    this.s.cfg[id].qty = Math.max(p.min, Math.min(10000, isNaN(q) ? p.min : Math.round(q)));
    this.renderLines();
    this.renderSummary();
  };

  Builder.prototype.bind = function () {
    var self = this, s = this.s, root = this.root;
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-action]');
      if (!el || !root.contains(el)) return;
      var a = el.getAttribute('data-action'), id = el.getAttribute('data-id'), v = el.getAttribute('data-value');
      if (a === 'cat') { s.cat = v; self.renderStep1(); }
      else if (a === 'toggle') {
        if (s.sel[id]) delete s.sel[id]; else { s.sel[id] = true; if (!s.cfg[id]) s.cfg[id] = self.defCfg(self.byId(id)); }
        self.renderStep1();
      }
      else if (a === 'go') {
        var to = parseInt(v, 10);
        if (to === 4 && !self.checkStep3()) return;
        self.go(to);
      }
      else if (a === 'remove') { delete s.sel[id]; self.renderLines(); self.renderSummary(); }
      else if (a === 'inc') self.setQty(id, s.cfg[id].qty + 1);
      else if (a === 'dec') self.setQty(id, s.cfg[id].qty - 1);
      else if (a === 'pick') self.setQty(id, parseInt(v, 10));
      else if (a === 'opt') { s.cfg[id].opt = parseInt(v, 10); self.renderLines(); self.renderSummary(); }
      else if (a === 'colour') { s.cfg[id].colour = parseInt(v, 10); self.renderLines(); self.renderSummary(); }
      else if (a === 'addon') { s.cfg[id].addon = !s.cfg[id].addon; self.renderLines(); self.renderSummary(); }
      else if (a === 'lead') { s.lead = v; self.renderLines(); self.renderSummary(); }
      else if (a === 'pickfiles') { self.$('[data-cs-picker]').click(); }
      else if (a === 'unfile') { self.files.splice(parseInt(v, 10), 1); self.syncFiles(); }
    });
    root.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-action="qty"]')) self.setQty(el.getAttribute('data-id'), parseInt(el.value, 10));
      else if (el.matches('[data-cs-picker]')) { self.addFiles(el.files); el.value = ''; }
      else if (el.matches('[data-cs-art]')) { self.renderSummary(); self.$('[data-cs-art-error]').hidden = true; }
      else if (el.matches('[data-cs-rights]')) { self.$('[data-cs-rights-error]').hidden = true; }
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-cs-search]')) { s.q = e.target.value; self.renderStep1(); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input:not([type="submit"])') && self.s.step !== 4) e.preventDefault();
    });
    var drop = this.$('[data-cs-drop]');
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) self.addFiles(e.dataTransfer.files); });
    this.form.addEventListener('submit', function (e) { if (!self.beforeSubmit()) e.preventDefault(); });
  };

  Builder.prototype.checkStep3 = function () {
    var ok = true;
    var rights = this.$('[data-cs-rights]');
    if (!rights.checked) { this.$('[data-cs-rights-error]').hidden = false; ok = false; }
    if (this.artValue() === 'upload' && !this.files.length) {
      var err = this.$('[data-cs-art-error]');
      err.hidden = false;
      ok = false;
    }
    return ok;
  };

  Builder.prototype.beforeSubmit = function () {
    var self = this, ok = true;
    this.form.querySelectorAll('[data-cs-required]').forEach(function (inp) {
      var bad = !inp.value.trim() || (inp.type === 'email' && !/.+@.+\..+/.test(inp.value));
      inp.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad) ok = false;
    });
    var err = this.$('[data-cs-submit-error]');
    var idInput = this.form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) { err.textContent = this.c.noProductMsg; err.hidden = false; return false; }
    if (!ok) { err.textContent = this.c.requiredMsg; err.hidden = false; return false; }
    err.hidden = true;
    var t = this.totals(), props = [], n = 0;
    function add(name, value) { props.push('<input type="hidden" name="properties[' + esc(name) + ']" value="' + esc(value) + '">'); }
    this.selected().forEach(function (p) {
      var c = self.s.cfg[p.id], pr = self.price(p, c);
      n += 1;
      add('Item ' + n, p.name + ': ' + self.meta(p, c) + ' | ' + (pr.quote ? 'priced by quote' : money(pr.unit) + ' each = ' + money(pr.total) + (pr.setup ? ' + ' + money(pr.setup) + ' setup' : '')));
    });
    if (this.hasPlanned()) add('Drinkware lead time', this.s.lead === 'planned' ? 'Planned ahead' : 'Standard');
    if (t.setup) add('Setup fees', money(t.setup));
    if (t.tidy) add('Logo tidy-up', money(t.tidy));
    add('Estimated total', money(t.total) + (t.anyQuote ? ' + items priced by quote' : '') + ' (no VAT)');
    if (t.anyLarge) add('Large order', this.c.largeQty + '+ of an item, ready date to confirm');
    this.$('[data-cs-props]').innerHTML = props.join('');
    var btn = this.$('[data-cs-submit]');
    btn.disabled = true;
    btn.textContent = this.c.sendingLabel;
    return true;
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-cs-builder]').forEach(function (root) {
      if (root.__csBuilder) return;
      root.__csBuilder = new Builder(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('[data-cs-submit]').forEach(function (b) { b.disabled = false; b.textContent = b.getAttribute('data-label'); });
  });
})();
